import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Paper,
} from "@mui/material";
import { toast } from "react-toastify";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import classes from "./Reseller.module.css";
import ResellerServices from "../../../services/reseller_services";

const ResellerList = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Mobile_Number: "",
    CountryCode: "+91",
    BusinessName: "",
    City: "",
    Province: "",
    Country: null,
    CountryName: "",
    CreditPricePackages: [
      {
        Credits: 1,
        AmountWithoutTax: "",
        AmountWithTax: "",
      },
    ],
  });

  const [errors, setErrors] = useState({});

  const getCurrencySymbol = (countryId) => {
    if (!countryId || !countries.length) return "$";

    const country = countries.find((c) => c.id === countryId);
    if (!country) return "$";

    const currencyMap = {
      India: "₹",
      "United States": "$",
      Canada: "C$",
      "United Arab Emirates": "د.إ",
    };

    return currencyMap[country.name] || "$";
  };

  useEffect(() => {
    console.log("Form data updated:", formData);
  }, [formData]);

  useEffect(() => {
    console.log("States array updated:", states);
  }, [states]);

  useEffect(() => {
    GetCountries()
      .then((result) => {
        console.log("Countries loaded:", result);
        console.log("First country structure:", result[0]);

        const india = result.find((country) => country.name === "India");
        const usa = result.find((country) => country.name === "United States");
        const canada = result.find((country) => country.name === "Canada");
        const uae = result.find(
          (country) => country.name === "United Arab Emirates"
        );

        console.log("India ID:", india?.id);
        console.log("USA ID:", usa?.id);
        console.log("Canada ID:", canada?.id);
        console.log("UAE ID:", uae?.id);

        setCountries(result);

        if (india) {
          setFormData((prev) => ({
            ...prev,
            Country: india.id,
            CountryName: india.name,
          }));
        }
      })
      .catch((error) => {
        console.error("Error loading countries:", error);
        setCountries([]);
      });
  }, []);

  useEffect(() => {
    if (formData.Country) {
      console.log("Loading states for default country:", formData.Country);
      GetState(parseInt(formData.Country))
        .then((result) => {
          console.log("Default states loaded for India:", result);
          console.log("State list type:", typeof result);
          console.log(
            "State list length:",
            result ? result.length : "null/undefined"
          );
          if (result && result.length > 0) {
            console.log("First state:", result[0]);
          }
          setStates(result || []);
        })
        .catch((error) => {
          console.error("Error loading default states:", error);
          setStates([]);
        });
    }
  }, []);

  useEffect(() => {
    if (formData.Country) {
      console.log("Country changed, loading states for:", formData.Country);
      GetState(parseInt(formData.Country))
        .then((result) => {
          console.log("States loaded for", formData.Country, ":", result);
          console.log("State list type:", typeof result);
          console.log(
            "State list length:",
            result ? result.length : "null/undefined"
          );
          if (result && result.length > 0) {
            console.log("First state structure:", result[0]);
          }
          setStates(result || []);
          setCities([]);
        })
        .catch((error) => {
          console.error("Error loading states:", error);
          setStates([]);
        });
    } else {
      console.log("No country selected, clearing states");
      setStates([]);
      setCities([]);
    }
  }, [formData.Country]);

  useEffect(() => {
    const loadCities = async () => {
      if (formData.Country && formData.Province) {
        try {
          const cityList = await GetCity(formData.Country, formData.Province);
          console.log(
            "Cities loaded for",
            formData.Country,
            formData.Province,
            ":",
            cityList
          );
          setCities(cityList);
        } catch (error) {
          console.error("Error loading cities:", error);
          setCities([]);
        }
      } else {
        setCities([]);
      }
    };
    loadCities();
  }, [formData.Country, formData.Province]);

  const handleCountryChange = (countryId) => {
    console.log("Country changed to:", countryId);

    const selectedCountry = countries.find((c) => c.id === parseInt(countryId));
    console.log("Selected country:", selectedCountry);

    setFormData((prev) => ({
      ...prev,
      Country: parseInt(countryId),
      CountryName: selectedCountry?.name || "",
      Province: "",
      City: "",
    }));
  };

  const handleStateChange = (stateCode) => {
    console.log("State changed to:", stateCode);
    setFormData((prev) => ({
      ...prev,
      Province: stateCode,
      City: "",
    }));
  };

  const handleInputChange = (field, value) => {
    console.log("Input changed:", field, "to:", value);
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleCreditPackageChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      CreditPricePackages: prev.CreditPricePackages.map((pkg, i) =>
        i === index ? { ...pkg, [field]: value } : pkg
      ),
    }));
  };

  const addCreditPackage = () => {
    setFormData((prev) => ({
      ...prev,
      CreditPricePackages: [
        ...prev.CreditPricePackages,
        {
          Credits: prev.CreditPricePackages.length + 1,
          AmountWithoutTax: "",
          AmountWithTax: "",
        },
      ],
    }));
  };

  const removeCreditPackage = (index) => {
    if (formData.CreditPricePackages.length > 1) {
      setFormData((prev) => ({
        ...prev,
        CreditPricePackages: prev.CreditPricePackages.filter(
          (_, i) => i !== index
        ),
      }));
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.Name.trim()) {
      newErrors.Name = "Name is required";
    }
    if (!formData.Email.trim()) {
      newErrors.Email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.Email)) {
      newErrors.Email = "Please enter a valid email";
    }
    if (!formData.BusinessName.trim()) {
      newErrors.BusinessName = "Business Name is required";
    }
    if (!formData.Country) {
      newErrors.Country = "Country is required";
    }

    formData.CreditPricePackages.forEach((pkg, index) => {
      if (!pkg.Credits || pkg.Credits <= 0) {
        newErrors[`credits_${index}`] = "Credits must be greater than 0";
      }
      if (!pkg.AmountWithoutTax || pkg.AmountWithoutTax <= 0) {
        newErrors[`amountWithoutTax_${index}`] =
          "Amount without tax is required";
      }
      if (!pkg.AmountWithTax || pkg.AmountWithTax <= 0) {
        newErrors[`amountWithTax_${index}`] = "Amount with tax is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fix the validation errors", {
        position: "bottom-left",
        autoClose: 5000,
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");

      const submitData = {
        Name: formData.Name.trim(),
        Email: formData.Email.trim(),
        BusinessName: formData.BusinessName.trim(),
        CountryName: formData.CountryName,
        CreditPricePackages: formData.CreditPricePackages.map((pkg) => ({
          Credits: parseInt(pkg.Credits),
          AmountWithoutTax: parseFloat(pkg.AmountWithoutTax),
          AmountWithTax: parseFloat(pkg.AmountWithTax),
        })),
      };

      if (formData.CountryName) {
        const countryCodeMap = {
          India: "IN",
          "United States": "US",
          Canada: "CA",
          "United Arab Emirates": "AE",
        };
        submitData.Country = countryCodeMap[formData.CountryName] || "IN";
      }

      if (
        typeof formData.Mobile_Number === "string" &&
        formData.Mobile_Number.trim()
      ) {
        submitData.Mobile_Number = parseInt(formData.Mobile_Number);
        submitData.CountryCode = formData.CountryCode;
      }
      if (typeof formData.City === "string" && formData.City.trim()) {
        submitData.City = formData.City;
      }
      if (typeof formData.Province === "string" && formData.Province.trim()) {
        submitData.Province = formData.Province;
      }

      const result = await ResellerServices.addReseller(token, submitData);

      if (result.status === 200 && result.data.message) {
        toast.success("Reseller added successfully!", {
          position: "bottom-left",
          autoClose: 5000,
        });
        handleResetForm();
      } else {
        toast.error(result.error || "Failed to add reseller", {
          position: "bottom-left",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error("An error occurred while adding reseller", {
        position: "bottom-left",
        autoClose: 5000,
      });
      console.log("Error occurred while adding reseller", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResetForm = () => {
    const india = countries.find((country) => country.name === "India");
    setFormData({
      Name: "",
      Email: "",
      Mobile_Number: "",
      CountryCode: "+91",
      BusinessName: "",
      City: "",
      Province: "",
      Country: india?.id || null,
      CountryName: india?.name || "",
      CreditPricePackages: [
        {
          Credits: 1,
          AmountWithoutTax: "",
          AmountWithTax: "",
        },
      ],
    });
    setErrors({});
    setCities([]);

    if (india?.id) {
      GetState(parseInt(india.id))
        .then((result) => {
          console.log("States loaded after reset:", result);
          setStates(result || []);
        })
        .catch((error) => {
          console.error("Error loading states after reset:", error);
          setStates([]);
        });
    }
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          Add New Reseller
        </Typography>
      </Box>

      {/* Add Reseller Form */}
      <Paper className={classes.formPaper}>
        <Box className={classes.formContent}>
          <Grid container spacing={3}>
            {/* Basic Information */}
            <Grid size={12}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Basic Information
              </Typography>
              <Divider className={classes.divider} />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Name *"
                value={formData.Name}
                onChange={(e) => handleInputChange("Name", e.target.value)}
                error={!!errors.Name}
                helperText={errors.Name}
                className={classes.textField}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Business Name *"
                value={formData.BusinessName}
                onChange={(e) =>
                  handleInputChange("BusinessName", e.target.value)
                }
                error={!!errors.BusinessName}
                helperText={errors.BusinessName}
                className={classes.textField}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Email *"
                type="email"
                value={formData.Email}
                onChange={(e) => handleInputChange("Email", e.target.value)}
                error={!!errors.Email}
                helperText={errors.Email}
                className={classes.textField}
              />
            </Grid>

            <Grid size={{ xs: 4, sm: 2 }}>
              <FormControl fullWidth className={classes.selectField}>
                <Select
                  value={formData.CountryCode}
                  onChange={(e) =>
                    handleInputChange("CountryCode", e.target.value)
                  }
                  displayEmpty
                  renderValue={(value) => value || "Code"}
                >
                  <MenuItem value="" disabled>
                    <em>Code</em>
                  </MenuItem>
                  <MenuItem value="+91">+91</MenuItem>
                  <MenuItem value="+1">+1</MenuItem>
                  <MenuItem value="+971">+971</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 8, sm: 4 }}>
              <TextField
                fullWidth
                label="Mobile Number"
                type="number"
                value={formData.Mobile_Number}
                onChange={(e) =>
                  handleInputChange("Mobile_Number", e.target.value)
                }
                inputProps={{
                  pattern: "[0-9]*",
                  inputMode: "numeric",
                }}
                className={classes.textField}
              />
            </Grid>

            {/* Location Information */}
            <Grid size={12}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Location Information
              </Typography>
              <Divider className={classes.divider} />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl
                fullWidth
                className={classes.selectField}
                error={!!errors.Country}
              >
                <InputLabel shrink={!!formData.Country}>Country *</InputLabel>
                <Select
                  value={formData.Country || ""}
                  onChange={(e) => handleCountryChange(e.target.value)}
                  label="Country *"
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Select a country</em>
                  </MenuItem>
                  {countries
                    .filter(
                      (country) =>
                        country.name === "India" ||
                        country.name === "United States" ||
                        country.name === "Canada" ||
                        country.name === "United Arab Emirates"
                    )
                    .map((country) => (
                      <MenuItem key={country.id} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                </Select>
                {errors.Country && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={classes.errorText}
                  >
                    {errors.Country}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth className={classes.selectField}>
                <InputLabel>State/Province</InputLabel>
                <Select
                  value={formData.Province || ""}
                  onChange={(e) => handleStateChange(e.target.value)}
                  label="State/Province"
                  disabled={!formData.Country}
                  displayEmpty
                >
                  {states.length > 0 ? (
                    states.map((state) => (
                      <MenuItem
                        key={state.isoCode || state.id || state.code}
                        value={state.isoCode || state.id || state.code}
                      >
                        {state.name || state.stateName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>
                      <em>No states available</em>
                    </MenuItem>
                  )}
                </Select>
                {!formData.Country && (
                  <Typography variant="caption" className={classes.helperText}>
                    Please select a country first
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <FormControl fullWidth className={classes.selectField}>
                <InputLabel shrink={!!formData.City}>City</InputLabel>
                <Select
                  value={formData.City || ""}
                  onChange={(e) => handleInputChange("City", e.target.value)}
                  label="City"
                  disabled={!formData.Province}
                  displayEmpty
                >
                  {cities.map((city) => (
                    <MenuItem
                      key={city.name || city.id}
                      value={city.name || city.cityName}
                    >
                      {city.name || city.cityName}
                    </MenuItem>
                  ))}
                </Select>
                {!formData.Province && (
                  <Typography variant="caption" className={classes.helperText}>
                    Please select a state first
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Credit Price Packages */}
            <Grid size={12}>
              <Box className={classes.creditPackagesHeader}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  Credit Packages *
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={addCreditPackage}
                  className={classes.addPackageButton}
                >
                  Add Package
                </Button>
              </Box>
              <Divider className={classes.divider} />
            </Grid>

            {formData.CreditPricePackages.map((pkg, index) => (
              <Grid size={12} key={index}>
                <Box className={classes.creditPackage}>
                  <Box className={classes.packageHeader}>
                    <Typography variant="subtitle1">
                      Package {index + 1}
                    </Typography>
                    {formData.CreditPricePackages.length > 1 && (
                      <IconButton
                        onClick={() => removeCreditPackage(index)}
                        className={classes.removeButton}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <TextField
                        fullWidth
                        label="Credits"
                        type="number"
                        value={pkg.Credits}
                        onChange={(e) =>
                          handleCreditPackageChange(
                            index,
                            "Credits",
                            e.target.value
                          )
                        }
                        error={!!errors[`credits_${index}`]}
                        helperText={errors[`credits_${index}`]}
                        className={classes.textField}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <TextField
                        fullWidth
                        label={`Amount Without Tax (${getCurrencySymbol(
                          formData.Country
                        )})`}
                        type="number"
                        value={pkg.AmountWithoutTax}
                        onChange={(e) =>
                          handleCreditPackageChange(
                            index,
                            "AmountWithoutTax",
                            e.target.value
                          )
                        }
                        error={!!errors[`amountWithoutTax_${index}`]}
                        helperText={errors[`amountWithoutTax_${index}`]}
                        className={classes.textField}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <TextField
                        fullWidth
                        label={`Amount With Tax (${getCurrencySymbol(
                          formData.Country
                        )})`}
                        type="number"
                        value={pkg.AmountWithTax}
                        onChange={(e) =>
                          handleCreditPackageChange(
                            index,
                            "AmountWithTax",
                            e.target.value
                          )
                        }
                        error={!!errors[`amountWithTax_${index}`]}
                        helperText={errors[`amountWithTax_${index}`]}
                        className={classes.textField}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box className={classes.formActions}>
          <Button onClick={handleResetForm} className={classes.resetButton}>
            Reset Form
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={isSubmitting}
            className={classes.submitButton}
          >
            {isSubmitting ? "Adding..." : "Add Reseller"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ResellerList;
